export const ApplicationConstant = {
    ApplicationID : 4,
    clientId : 4,
    organizationId: 4,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 5
}